export const encodeString = (str: string | undefined) => {
  if (str === undefined) {
    return '';
  }
  const safeStr = str?.replace(/\./g, '%2E');

  return encodeURIComponent(safeStr);
};
